var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vModal vModalDefault", class: _vm.$style.dialog },
    [
      _c("div", { class: _vm.$style.header }, [
        _c("img", {
          class: _vm.$style.headerIcon,
          attrs: { src: require("images/ui/icon-warning.svg"), alt: "Warning" },
        }),
        _c("div", [
          _c("h2", { class: _vm.$style.headerSub }, [
            _c("span", { class: _vm.$style.headerSubText }, [
              _vm._v("Please Note"),
            ]),
          ]),
          _c("h1", { class: _vm.$style.headerMain }, [
            _c("span", { class: _vm.$style.headerMainText }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
          ]),
        ]),
        _c(
          "button",
          {
            staticClass: "vModalDefaultCloseButton",
            on: {
              click: function ($event) {
                return _vm.hide()
              },
            },
          },
          [_vm._v(" close ")]
        ),
      ]),
      _c("div", { class: _vm.$style.modalBody }, [
        _c("div", {
          class: _vm.$style.bodyText,
          domProps: { innerHTML: _vm._s(_vm.htmlMessage) },
        }),
        _c(
          "div",
          { class: _vm.$style.list },
          [
            _c("div", { class: _vm.$style.listHeading }, [
              _c("div", { class: _vm.$style.listHeadingName }, [
                _vm._v(" Bid - Supplier Name "),
              ]),
              _c("div", { class: _vm.$style.listHeadingStatus }, [
                _vm._v(" Bid Status "),
              ]),
            ]),
            _vm._l(_vm.items, function (item) {
              return _c("report-item", {
                key: item.tObject._id,
                attrs: { report: item, messages: _vm.messages },
              })
            }),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "vModalDefaultFooter" },
        [
          _vm._t("footer", function () {
            return [
              _c(
                "button",
                {
                  staticClass: "rbButton mainButton",
                  class: _vm.$style.okButton,
                  on: {
                    click: function ($event) {
                      return _vm.hide()
                    },
                  },
                },
                [_vm._v(" OK ")]
              ),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }